import script from "./TemplateDefault.vue?vue&type=script&setup=true&lang=js"
export * from "./TemplateDefault.vue?vue&type=script&setup=true&lang=js"

import "./TemplateDefault.vue?vue&type=style&index=0&id=8a1fa598&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a1fa598"]])

export default __exports__